class UidDerivation {
    slugify(value) {
        let result = String(value);
        result = result.toLowerCase();
        result = result.replace(/ /g, '_');
        result = result.replace(/:/g, '_');
        result = result.replace(/[^a-z0-9\-_]/g, '');
        result = result.slice(0, 32);
        result = result.replace(/[-_]+$/, '');
        return result;
    }

    deriveUid(config, isUidTaken) {
        const skipKeys = new Set(['namespace', 'uid', 'parentUid', 'configSnippets']);

        const isDynamic = (val) =>
            typeof val === 'string' && (val.includes('@{') || val.includes('!{') || val.includes('${'));

        const isValidValue = (val) => typeof val === 'string' || typeof val === 'number';

        const scanProperties = (obj, matchFn) => {
            for (const key of Object.keys(obj)) {
                if (skipKeys.has(key)) continue;
                const val = obj[key];
                if (val !== null && typeof val === 'object' && !Array.isArray(val)) {
                    const found = scanProperties(val, matchFn);
                    if (found !== undefined) return found;
                } else if (isValidValue(val) && matchFn(key, val)) {
                    const strVal = String(val);
                    if (isDynamic(strVal)) continue;
                    return { key, value: strVal };
                }
            }
            return undefined;
        };

        // Step 1: id property
        if (config.id !== undefined && typeof config.id === 'string' && config.id !== '' && !isDynamic(config.id)) {
            const base = this.slugify(config.id);
            if (base) return this._resolveUnique(base, isUidTaken, false);
        }

        // Step 2: filename-like property
        const filenameMatch = scanProperties(config, (key) =>
            key.endsWith('Id') || key === 'src' || key === 'samplemap'
        );
        if (filenameMatch) {
            let val = filenameMatch.value;
            if (val.includes('://') || val.startsWith('/')) {
                // Extract filename without extension
                const parts = val.split('/');
                let filename = parts[parts.length - 1];
                const dotIdx = filename.lastIndexOf('.');
                if (dotIdx > 0) filename = filename.slice(0, dotIdx);
                val = filename;
            }
            const base = this.slugify(val);
            if (base) return this._resolveUnique(base, isUidTaken, false);
        }

        // Step 3: content-like property
        const contentMatch = scanProperties(config, (key) =>
            key === 'content' || key === 'name' || key === 'placeholder'
        );
        if (contentMatch) {
            let val = contentMatch.value;
            if (val.includes(' ')) {
                val = val.split(/\s+/).slice(0, 3).join(' ');
            }
            const base = this.slugify(val);
            if (base) return this._resolveUnique(base, isUidTaken, false);
        }

        // Step 4: index fallback
        const ns = config.namespace || '';
        const segments = ns.split(':');
        const lastSegment = segments[segments.length - 1] || 'node';
        return this._resolveUnique(lastSegment, isUidTaken, true);
    }

    _resolveUnique(base, isUidTaken, indexMode) {
        if (indexMode) {
            let i = 0;
            while (true) {
                const candidate = `${base}-${i}`;
                if (!isUidTaken(candidate)) return candidate;
                i++;
            }
        }

        if (!isUidTaken(base)) return base;
        let i = 2;
        while (true) {
            const candidate = `${base}-${i}`;
            if (!isUidTaken(candidate)) return candidate;
            i++;
        }
    }
}

const uidDerivation = new UidDerivation();

export { UidDerivation, uidDerivation };
